import { useTranslation } from "react-i18next";
import type { BaseButtonStyle } from "components/designV2/buttons/baseButton";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import {
  BulkActionBar,
  BulkActionBarButtons,
  BulkActionBarCard,
  BulkActionBarCount,
} from "./applicationList.styled";

interface Props {
  readonly isLoading: boolean;
  readonly selectedCount: number;
  readonly onAssign: () => void;
  readonly onReject: () => void;
}

const ASSIGN_BUTTON_STYLES: Partial<BaseButtonStyle> = {
  backgroundColor: ColorV2.PositiveGreen,
  hoverBackgroundColor: ColorV2.SimflexityGreen,
  activeBackgroundColor: ColorV2.SimflexityGreen,
  textColor: ColorV2.White,
  borderColor: "transparent",
  iconColor: ColorV2.White,
};

const REJECT_BUTTON_STYLES: Partial<BaseButtonStyle> = {
  borderColor: ColorV2.NegativeRed,
  textColor: ColorV2.NegativeRed,
  iconColor: ColorV2.NegativeRed,
  hoverBackgroundColor: ColorV2.NegativeRedLight,
  activeBackgroundColor: ColorV2.WithdrawnPink,
};

export const ApplicationListBulkActions = (
  props: Props,
): JSX.Element | null => {
  const { t } = useTranslation();
  if (props.selectedCount === 0) return null;

  return (
    <BulkActionBar>
      <BulkActionBarCard>
        <BulkActionBarCount>
          {t("ApplicationsCompany.SelectedCount", {
            count: props.selectedCount,
          })}
        </BulkActionBarCount>
        <BulkActionBarButtons>
          <SecondaryButton
            size="small"
            label={t("GigsCompany.Reject")}
            styleOverrides={REJECT_BUTTON_STYLES}
            disabled={props.isLoading}
            onClick={props.onReject}
          />
          <PrimaryButton
            size="small"
            label={t("ApplicationsCompany.Assign")}
            styleOverrides={ASSIGN_BUTTON_STYLES}
            disabled={props.isLoading}
            isLoading={props.isLoading}
            onClick={props.onAssign}
          />
        </BulkActionBarButtons>
      </BulkActionBarCard>
    </BulkActionBar>
  );
};
